import { Component, ViewChild, HostListener, OnInit } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router, NavigationStart, RouterModule } from '@angular/router';
import { BsModalRef, ModalDirective, BsModalService } from 'ngx-bootstrap/modal';
import { AuthService } from './services/auth-service/auth.service';
import { Labels } from './constants/labels';
import $ from 'jquery';
import { CommonService } from './services/common-service/common.service';
import { KEYS } from './constants/keys';
import { isData } from './utils/utils';
import { SessionTimerService } from './services/session-timer.service';
import { FullscreenService } from './services/fullscreen.service';
import { SlowRequestService } from './services/slow-request/slow-request.service';
import { LoaderService } from './services/loader-service/loader.service';
import { GstiLoaderComponent } from './components/gsti-loader/gsti-loader.component';
import { SrcPath } from './constants/srcPath';
import { PopupHostComponent } from './shared/popup/popup-host/popup-host.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [ModalDirective, RouterModule, GstiLoaderComponent,PopupHostComponent],
  providers:[ 
    Idle,Keepalive]
})
export class AppComponent {

  srcPath = SrcPath;
  idleState = 'Not started.';
  timeOut = false;
  lastPing?: any = null;
  title = 'BackOffice';
  labelSession = Labels.messages.session_out;
  labelLoadingSession = Labels.messages.loading_out;
  labelErrorLoadingSession = Labels.messages.error_loading;
  labelNetworkFailureSession = Labels.messages.network_failure;
  
  public modalRef!: BsModalRef;

  @ViewChild('childModal', { static: false }) childModal: ModalDirective | any;
  @ViewChild('slowNetworkModal', { static: false }) slowRequestModal: ModalDirective | any;
  @ViewChild('errorNetworkModal', { static: false }) errorRequestModal: ModalDirective | any;
  @ViewChild('neworkFailureModal', { static: false }) neworkFailureModal: ModalDirective | any;

  constructor(private idle: Idle,
    private keepalive: Keepalive,
    private router: Router,
    private modalService: BsModalService,
    private authService: AuthService,
    private loaderService: LoaderService,
    public commonService: CommonService, private sessionTimer: SessionTimerService,
    private fullScreenService:FullscreenService,
    private slowService: SlowRequestService
    ) {

    // Sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle((60 * 240));

    idle.setTimeout(5);

    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.'
      this.commonService.ogLog(this.idleState);
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      // this.childModal.hide();
      this.idleState = 'Time out!';
      this.timeOut = true;
      this.commonService.ogLog(this.idleState);
      this.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      this.commonService.ogLog(this.idleState);
      this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown: any) => {
      // this.idleState = 'You will time out in ' + countdown + ' seconds!';
      this.idleState = this.labelSession.message.replace('~', countdown);
      this.commonService.ogLog(this.idleState);
    });

    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    authService.getUserLoggedIn().subscribe(userLoggedIn => {
      if (userLoggedIn) {
        this.reset();
      } else {
        idle.stop();
      }
    });
  }

  ngOnInit() {
    this.slowService.slowRequestTrigger.subscribe(() => {
      this.openSlowPopup();
    });
    this.slowService.networkErrorTrigger.subscribe(() => {
      this.handleNetworkFailure();
    })
    this.loaderService.noPendingRequestTrigger.subscribe(() => {
      this.handleNoPendingRequest();
    })
  }
  
  openSlowPopup() {
    if (!this.slowRequestModal?.isShown && this.loaderService.requestCount != 0) {
      if (this.router.url.includes('userlogin')) {
        return;
      }
      this.slowRequestModal.show();
    }
  }

  handleNetworkFailure() {
    this.slowRequestModal.hide();
    if (!this.errorRequestModal?.isShown && this.loaderService.requestCount != 0 && !navigator.onLine) {
      if (this.router.url.includes('userlogin')) {
        return;
      }
      this.neworkFailureModal.show();
    }
    // this.authService.signOut();
  }

  handleNoPendingRequest() {
    this.slowRequestModal.hide();
  }

  onStaySlowRequest() {
    this.slowRequestModal.hide();
    this.slowService.stopWatch();
  }

  onLeaveSlowRequest() {
    this.slowService.stopWatch();
    this.slowRequestModal.hide();
    this.errorRequestModal.show();
  }
  onOkErrorRequest() {
    this.loaderService.endAllRequests();
    this.errorRequestModal.hide();
  }

  onExitNWFailure() {
    this.neworkFailureModal.hide();
    // this.authService.signOut();
    this.logout();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timeOut = false;
  }

  hideChildModal(): void {
    this.childModal.hide();
  }

  stay() {
    this.childModal.hide();
    this.reset();
  }
  // change by swati 17112021
  logout() {
    this.childModal.hide();

    $('.modal').remove();
    $('.modal-backdrop').remove();
    $('.modal-open').removeClass('modal-open');
    let accountID = this.commonService.getUserCredentials(KEYS.credential_account_id)
    let loginHistoryId = sessionStorage.getItem(KEYS.loginHistoryId);
    const sessionDuration = this.sessionTimer.stopTimer();
    this.commonService.updateSessionAutoLogout(loginHistoryId, 1).subscribe(data => { }, error => { })
    this.fullScreenService.exit();
    this.authService.signOut();
    this.commonService.logoutupdate(accountID).subscribe(data => {
      if (isData(data)) {
      }
    }, error => { });

  }
  ngOnDestroy(): void {
    this.logout();
  }

  // @HostListener('window:beforeunload', ['$event']) beforeunloadHandler(event: Event) {
  //   this.commonService.ogLog('in unload...', event.type);
  //   if(this.commonService.getSkipLogout()){
  //     this.commonService.setSkipLogout(false);
  //     return;
  //   }
  //   let preload = false;
  //   preload = window.performance.getEntriesByType('navigation').map((nav) => (nav as any).type).includes('reload');
  //   if (preload == false)
  //     this.logout();
  // }

}
